import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { StatusDTO, Theme } from '../../gdo-shared/Models/Models';
import { IAcctDetail } from '../../gdo-shared/Models/Interfaces';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import {
  Ca_State_prov,
  Us_State_prov,
  transformIntoApiCallObj,
} from '../../gdo-shared/Models/Constants';
import { GdoStepCompletionStatusComponent } from '../../gdo-shared/gdo-shared-components/gdo-step-completion-status/gdo-step-completion-status.component';
import { GdoStepCompletionStatusWebviewComponent } from '../../gdo-shared/gdo-shared-components/gdo-step-completion-status-webview/gdo-step-completion-status-webview.component';

@Component({
    selector: 'app-gdo-contact-subscription-webview',
    templateUrl: './gdo-contact-subscription-webview.component.html',
    styleUrls: ['./gdo-contact-subscription-webview.component.scss'],
    standalone: false
})
export class GdoContactSubscriptionWebviewComponent implements OnInit {
  // theme: Theme = 'dark-theme';
  @Input() type!: string;
  @Input() subsForm!: UntypedFormGroup;

  data!: IAcctDetail;
  editContactInfo!: UntypedFormGroup;
  formData = null;
  isWebView: boolean = false;
  isAcura: boolean = false;
  primaryPhoneTypes = [{ value: 'Mobile' }, { value: 'Landline' }];
  secondaryPhoneTypes = [{ value: 'Work' }, { value: 'Work' }];
  preferredLanguage = [
    { displayValue: 'English', value: 'System_US_English_locale' },
    { displayValue: 'French', value: 'fr_CAN' },
  ];
  countries = [
    { displayValue: 'United States', value: 'US' },
    { displayValue: 'Canada', value: 'CA' },
  ];

  stateProvDropdown: any;
  validators = [
    this._appService.nameValidation,
    this._appService.phoneNoValidation,
    this._appService.zipCodeValidation,
    this._appService.cityAddressValidation,
  ];

  constructor(
    private _appService: AppService,
    private router: Router,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2 // private location: Location
  ) {}

  ngOnInit(): void {
    // ;

    if (this._appService.getWebviewCurrentStatus()) {
      this.isWebView = true;
    } else {
      this.isWebView = false;
    }

    this.setIsAcuraLocally();
    
    this.data = this._appService.getAccDetails();
    this.initEditContactInfoForm();
    // this.switchTheme();
  }

  setIsAcuraLocally() {
    let vehicleData = sessionState.getItem('vehicleMake');
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
  }

  initEditContactInfoForm() {
    this.editContactInfo = new UntypedFormGroup(
      {
        first_name: new UntypedFormControl(this.data?.firstName, Validators.required),
        last_name: new UntypedFormControl(this.data?.lastName, Validators.required),
        phone: new UntypedFormControl(
          convertToUsFormat(this.data?.phone),
          Validators.required
        ),
        address1: new UntypedFormControl(this.data?.address1, Validators.required),
        address2: new UntypedFormControl(this.data?.address2),
        cell_phone: new UntypedFormControl(convertToUsFormat(this.data?.cellPhone)),
        city: new UntypedFormControl(this.data?.city, Validators.required),
        country_cd: new UntypedFormControl(this.data?.countryCode),
        state_prov: new UntypedFormControl(this.data?.stateProv),
        mobile_prov: new UntypedFormControl(''),
        company_name: new UntypedFormControl(this.data?.companyName),
        email: new UntypedFormControl({ value: this.data?.email, disabled: true }),
        locale_name: new UntypedFormControl(this.data?.acctLocaleName),
        postal_cd: new UntypedFormControl(this.data?.postalCode, Validators.required),
      },
      this.validators
    );
    this.onCountryChange(null);
  }

  onCountryChange(event: any) {
    const selectedCountry = this.editContactInfo?.value?.country_cd;
    if (selectedCountry && selectedCountry === 'US') {
      this.stateProvDropdown = Us_State_prov;
    } else if (selectedCountry && selectedCountry === 'CA') {
      this.stateProvDropdown = Ca_State_prov;
    }
  }

  onSaveClick() {
    if (this.editContactInfo.valid) {
      const acctDetails = this._appService.getAccDetails();
      let billing_group_no =
        acctDetails.billingGroupsInfo &&
        acctDetails.billingGroupsInfo.length > 0
          ? acctDetails.billingGroupsInfo[0].billingGroupNo
          : null;
      let bill_contact_no =
        acctDetails.paymentMethodsInfo &&
        acctDetails.paymentMethodsInfo.length > 0
          ? acctDetails.paymentMethodsInfo[0].billContactNo
          : null;
      let contacts_list = [];
      let composeObject: any;

      let reqObj;
      let data = Object.assign(this.editContactInfo.value);
      // data.phone = convertToNumericDigits(data.phone);
      // data.cell_phone = convertToNumericDigits(data.cell_phone);
      // data.address2 = this.tildeConversion(data.address2);
      // data.city = this.tildeConversion(data.city);
      // data.company_name = this.tildeConversion(data.company_name);

      let contacts_list_obj: any = {
        addr_contact_idx: 1,
        addr_first_name: data.first_name,
        addr_last_name: data.last_name,
        addr_phone: data.phone,
        addr_cell_phone: data.cell_phone,
        addr_address1: data.address1,
        addr_address2: data.address2,
        addr_city: data.city,
        addr_country: data.country_cd,
        addr_state_prov: data.state_prov,
        addr_email: acctDetails.email,
        addr_postal_cd: data.postal_cd,
        addr_company_name: data.business_name,
      };
      composeObject = {
        locale_name: data.locale_name,
        acct_contact_idx: 1,
        billing_groups_array: [
          {
            stmt_contact_idx: 1, //hardcode as discussed with wajid
            billing_group_no,
          },
        ],
        // payment_methods_array: [{
        //   bill_contact_idx: 1,//hardcode as discussed with wajid
        //   // bill_contact_no: bill_contact_no,
        //   "payment_method_no": 1, // need to ask honda to include it
        // }],
        contacts_list: [contacts_list_obj],
      };

      reqObj = transformIntoApiCallObj(composeObject, 'update_acct_complete_m');
      

      this._appService.AriaPassThroughConnect(reqObj).subscribe((res) => {
        if (res && res.error_msg === 'OK' && res.error_code === 0) {
          let statusData: StatusDTO = {
            title: 'Contact Updated',
            details: 'Contact Information has been updated',
            stepSuccessful: true,
          };

          let ref = this.dialog.open(GdoStepCompletionStatusWebviewComponent, {
            data: statusData,
            panelClass: 'custom-modalbox',
          });

          ref.afterClosed().subscribe((result) => {
            this.router.navigate(['/gdoWV'], { replaceUrl: true });
          });
        } else {
          let statusData: StatusDTO = {
            title: 'Error occured',
            details: res.error_msg,
            stepSuccessful: false,
          };

          let ref = this.dialog.open(GdoStepCompletionStatusWebviewComponent, {
            data: statusData,
          });
        }
      });
    }
  }

  tildeConversion(value: string) {
    if (value && value.length > 0) {
      return value;
    } else return '~';
  }

  onBackClick() {
    // this.router.navigate(['/gdo-product'], { replaceUrl: true });
    this.router.navigate(['/gdoWV']);
  }



  trackByNgForItem(index: number, item: any): string | number {
    return item?.value ?? item?.payment_method_no ?? item?.paymentMethodNo ?? item?.couponCode ?? item?.id ?? item?.title ?? item?.displayValue ?? item ?? index;
  }
}
function convertToUsFormat(phone: string | undefined): string | null {
  if (phone) {
    phone = phone.replace(/[^\d]/g, '');
    return phone.replace(/(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
  } else {
    return null;
  }
}

function convertToNumericDigits(phone: string): any {
  if (phone && phone.length > 0) {
    phone = phone.replace(/[() -]/g, '');
    return phone;
  } else {
    return '~';
  }
}
